const highlightSelectedTextStyle = theme => ({
    highlighted: { backgroundColor: theme.palette.button.hover },
    disabled: { color: theme.palette.text.disabled },
});

export default highlightSelectedTextStyle;
